import {
  withTranslation,
} from 'react-i18next';

import RegattaSponsorFieldsView from './RegattaSponsorFieldsView';

const TranslatedComponent = withTranslation()(RegattaSponsorFieldsView);

const Component = TranslatedComponent;

export default Component;
